// Twin of the legacy `Scripts/Backports/utils/newMenu.ts`; the two must stay in step.

export interface MenuResolutionInput {
    readonly newNavigationEnabled: boolean;
    readonly useOldMenuLocally: boolean;
}

export function usesNewMenu({
    newNavigationEnabled,
    useOldMenuLocally,
}: MenuResolutionInput): boolean {
    return newNavigationEnabled && !useOldMenuLocally;
}
